<template>
  <div>
    <alert ref="alert" />
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-modal ref="modal" centered no-fade hide-header hide-footer cancel-disabled class="text-left">
      <p>Fill in form to request log in credentials and additional information</p>
      <b-form validate @submit="send">
        <b-form-group class="my-0 position-relative required">
          <b-form-input type="text" id="firstName" v-model="$v.firstName.$model" @input="$v.firstName.$touch()" :state="!$v.firstName.$error && null" placeholder="First Name" class="my-2" />
          <b-form-invalid-feedback v-if="!$v.firstName.required">First Name is required.</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.firstName.minLength">First Name must have at least {{$v.firstName.$params.minLength.min}} letters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="my-0 position-relative required">
          <b-form-input type="text" id="lastName" v-model="$v.lastName.$model" @input="$v.lastName.$touch()" :state="!$v.lastName.$error && null" placeholder="Last Name" class="my-2" />
          <b-form-invalid-feedback v-if="!$v.lastName.required">Last Name is required.</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.lastName.minLength">Last Name must have at least {{$v.lastName.$params.minLength.min}} letters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-input type="text" id="company" v-model="company" placeholder="Company" class="my-2" />
        <b-form-input type="text" id="position" v-model="position" placeholder="Position" class="my-2" />
        <b-form-group class="my-0 position-relative required">
          <b-form-input type="email" id="email" v-model="$v.email.$model" @input="$v.email.$touch()" :state="!$v.email.$error && null" placeholder="Email" class="my-2" />
          <b-form-invalid-feedback v-if="!$v.email.required">Email is required.</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.email.email">Please enter a valid email.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-input type="text" id="phone" v-model="phone" placeholder="Phone Number" class="my-2" />
        <b-form-textarea
          id="textarea"
          v-model="comments"
          placeholder="Comments or Messages"
          rows="3"
          max-rows="6"
          class="my-2" />
        <b-button type="submit" size="sm" class="float-right" variant="primary">Send</b-button>
      </b-form>
      <span style="color: #dc3545; font-size: 0.8rem"> * required </span>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import service from '../services/HttpRequestService';
import Alert from './Alert';
import { TRACE_ERROR } from '../constants';

export default {
  data() {
    return {
      type: '',
      firstName: '',
      lastName: '',
      company: '',
      position: '',
      email: '',
      phone: '',
      comments: '',
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      },
      showSpinner: false
    };
  },
  validations: {
    firstName: {
      required,
      minLength: minLength(1)
    },
    lastName: {
      required,
      minLength: minLength(1)
    },
    email: {
      required,
      email
    }
  },
  methods: {
    async send(evt) {
      evt.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.showSpinner = true;
        let reqBody = {
          Type: this.type,
          FirstName: this.firstName,
          LastName: this.lastName,
          Company: this.company,
          Position: this.position,
          Email: this.email,
          PhoneNumber: this.phone,
          Comments: this.comments
        };
        try {
          let res = await service.sendContactRequest(reqBody);
          if (res.data) {
            this.$refs.alert.showAlert('success', 'Thank you for contacting us.');
          } else {
            await service.log(TRACE_ERROR, 'Sending error', '');
            throw 'Sending error';
          }
        } catch (err) {
          const errMessage =
            'Failed to send contact request. Please contact info@chasenenterprises.com';
          await service.log(TRACE_ERROR, errMessage, err.stack);
          this.$refs.alert.showAlert('danger', errMessage);
        }
        this.hideModal();
        this.showSpinner = false;
      }
    },
    showModal(type) {
      this.$v.$reset();
      this.type = type;
      this.firstName = '';
      this.lastName = '';
      this.company = '';
      this.position = '';
      this.email = '';
      this.phone = '';
      this.comments = '';
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    }
  },
  components: {
    Alert
  }
};
</script>

<style lang="scss" scoped>
.required {
  &:before {
    content: '*';
    color: red;
    position: absolute;
    top: 8px;
    left: -8px;
  }
}
</style>
